import styled from "styled-components";

export const Wrapper = styled.main`

`;

export const Main = styled.section`
  display: grid;
  grid-template-columns: 600px 300px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    padding: 10px;
  }
`;

export const Slogan = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  > h1 {
    font-size: 24px;
    margin-bottom: 8px
  }

  > p {
    font-size: 12px;
  }
`;

export const Profile = styled.div`
  text-align: center;
  padding: 40px 0;
  max-width: 300px;
  display:  flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  > img {
    width: 100px;
    border-radius: 4px;
    vertical-align: middle;
    object-fit: contain;
    box-shadow: -8px 12px 13px -9px rgb(0 0 0 / 75%);
  }
`;

export const Basic = styled.ul`
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
`;

export const BasicItem = styled.li`
  display: flex;
  margin-left: 10px;
  justify-content: flex-start;
  padding: 2px 0;
`;

export const Social = styled.ul`
  list-style-type: none;
  overflow: hidden;
  text-align: center;
  bottom: 25px;
`;
export const SocialItem = styled.li`
  vertical-align: middle;
  line-height: 100%;
  display: inline-block;
  cursor: pointer;

  > a > img {
    height: 20px;
    vertical-align: middle;
    margin: 5px 3px;
  }

  > a > label:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  > a > label {
    display: none;
  }

`;
